import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    InputGroup,
    Button, InputGroupAddon
} from 'reactstrap';
import {ErrorMessage, useForm} from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";

// components
import SelectGeneric from '../../../components/select/selectGeneric';
import { MapPickerModal } from "../../../components/map/MapPickerModal";

// labels
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {INTERNATIONAL, REQUIRED} from "../../../components/i18n/i18n";

// services & providers
import { placeProvider } from "../../../providers/placeProvider";
import { placeService } from "../../../jwt/_services/hotel/placeService";
import { hotelCategoryProvider } from "../../../providers/hotelCategoryProvider";

// actions
import { syncGallery} from "../../../redux/actions/hotel/placeActions";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import PlaceLangs from "./_langs";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

const PlaceServicesForm = ( props ) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject, mapConfig} = componentState?.data;

    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState( domainObject?.status || false);
    const [category, setCategory] = useState( domainObject?.category || null);
    const [parentPlace, seParentPlace] = useState( domainObject?.parentPlace || null);
    const [typePlace, setTypePlace] = useState( domainObject?.typePlace || null);
    const [position, setPosition] = useState(editMode ? {
        lat: parseFloat(domainObject?.latitude),
        lng: parseFloat(domainObject?.longitude)
    } : mapConfig?.mapOptions?.center );

    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showMapModal, setShowMapModal] = useState(true);
    const modalMapRef = useRef(null);


    const showMap = () => {
        setShowMapModal(true);
        modalMapRef.current.showModal(mapConfig);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,

            code: (domainObject?.code || `${udn?.code}_serv_` + getCurrentDateForCodeField()).toLowerCase(), // AUTOCODE
            status: domainObject?.status,
            colorMarkerMap: domainObject?.colorMarkerMap || '#f62eab',
            iconMap: domainObject?.iconMap,
            latitude: domainObject?.latitude ?? 0.0,
            longitude: domainObject?.longitude ?? 0.0,
            level: domainObject?.level,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                id: domainObject?.id,
                udn: {id: udn?.id},

                typePlace : { id : '2F68BCB1-11BA-43C1-AB52-47789C796D33' },
                latitude: position?.lat,
                longitude: position?.lng,

                status: status,

                langs: langs,
            }
        };

        if (parentPlace)
            dataRequest.item.parentPlace = { id: parentPlace };

        if (category)
            dataRequest.item.category = { id: category };

        if (typePlace)
            dataRequest.item.typePlace = { id: '2F68BCB1-11BA-43C1-AB52-47789C796D33' };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, placeService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, placeService, dataRequest)
        }

        returnToList()
    };


    const onLatChange = (value ) => {
        setPosition({
            ...position,
            lat : value
        })
    }

    const onLngChange = ( value ) => {
        setPosition({
            ...position,
            lng : value
        })
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: placeService
        } );
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Card className={'card-modal-full'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { (udn.value || '')  + ' / ' + (domainObject?.title?.toUpperCase() || '')  }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { ' uid: ' + (domainObject?.uid || '') }</h5>
                        </>
                        <div className="float-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    <TranslateButton item={domainObject} service={placeService} path={path}/>
                                    <GenericButton
                                        style={'danger-secondary'}
                                        toolTip={TT_DELETE}
                                        icon={'fa-trash'}
                                        permission={'delete'}
                                        onClick={_ => confirmDelete(domainObject)}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={returnToList}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="8">
                                <FormGroup>
                                    <Label>{'Código'}</Label>
                                    <Input
                                        type="text"
                                        name="code"
                                        placeholder="Código"
                                        innerRef={register}
                                        className={(errors.code ? ' is-invalid' : '')}
                                    />
                                    { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label >Color </Label>
                                    <div className="form-control-color-input">
                                        <Input type="color"  name="colorMarkerMap" innerRef={register} />
                                    </div>
                                    <Input type="text"  name="colorMarkerMap" innerRef={register} />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>{'Categoría'}</Label>
                                    <br/>
                                    <SelectGeneric
                                        initialValue={ category }
                                        setExternalValue={ setCategory }
                                        provider={hotelCategoryProvider}
                                        getAllCategories={true}
                                    />
                                </FormGroup>
                            </Col>
                            {/*<Col md="6">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>Lugar donde se ubica</Label>*/}
                            {/*        <br/>*/}
                            {/*        <SelectGeneric*/}
                            {/*            initialValue={ parentPlace }*/}
                            {/*            setExternalValue={ seParentPlace }*/}
                            {/*            provider={ placeProvider }*/}
                            {/*            customFilter={{ item : {udn: {id: udn.id}}} }*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col md="8">
                                <FormGroup>
                                    <Label >{'Latitud y longitud'}</Label>
                                    <InputGroup>
                                        <Button color=" background-color-primary" onClick={ showMap } >
                                            <i className="fas fa-map-marker-alt text-white"/>
                                        </Button>
                                        <InputGroupAddon addonType="append">
                                            <Input type="number"
                                                   name="lat"
                                                   value={position?.lat}
                                                   className={'lat-lng-input'}
                                                   step={'0.0000001'}
                                                   onChange={e => onLatChange(e.target.value)}
                                            />
                                        </InputGroupAddon>
                                        <InputGroupAddon addonType="append">
                                            <Input type="number"
                                                   name="lng"
                                                   className={'lat-lng-input'}
                                                   value={ position?.lng}
                                                   step={'0.0000001'}
                                                   onChange={e => onLngChange(e.target.value)}
                                            />
                                        </InputGroupAddon>
                                    </InputGroup>
                                    <ErrorMessage errors={errors} name="latitude" component="div"
                                                  className="invalid-feedback"/>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Icono</Label>
                                    <Input
                                        type="text"
                                        name="iconMap"
                                        placeholder="Icono"
                                        innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                            {/*<Col md="1">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label>Nivel</Label>*/}
                            {/*        <Input*/}
                            {/*            type="text"*/}
                            {/*            name="level"*/}
                            {/*            placeholder="Nivel"*/}
                            {/*            innerRef={register}*/}
                            {/*        />*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col md="2">
                                <FormGroup>
                                    <Label>Activo</Label>
                                    <br/>
                                    <Switch
                                        animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={ status }
                                        onChange={ _ => setStatus(!status) }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{INTERNATIONAL}</h2>
                            </div>
                            <div className={''}>
                                <Row>
                                    <Col md="12">
                                         <PlaceLangs appCode={app?.code} langs={langs} setLangs={setLangs}
                                                    translatableLangs={translatableLangs}/>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Form>
            {
                showMapModal && <MapPickerModal
                    ref={modalMapRef}
                    setPosition={setPosition}
                    initialPosition={position}
                    googleConfig={mapConfig}
                    updateMarkerPosition={true}
                />
            }
        </>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
    syncGallery
})

export default connect(mapStateToProps, mapActionsToProps)(PlaceServicesForm)
